import { render, staticRenderFns } from "./stock-order.vue?vue&type=template&id=420868f9&scoped=true"
import script from "./stock-order.vue?vue&type=script&lang=js"
export * from "./stock-order.vue?vue&type=script&lang=js"
import style0 from "./stock-order.vue?vue&type=style&index=0&id=420868f9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420868f9",
  null
  
)

export default component.exports